export default __webpack_public_path__ + "static/media/icon-notification-circle-outline.7d78471a.svg";